import { render } from "./paydetail.vue?vue&type=template&id=2e37ba56&scoped=true"
import script from "./paydetail.vue?vue&type=script&lang=js"
export * from "./paydetail.vue?vue&type=script&lang=js"

import "./paydetail.vue?vue&type=style&index=0&id=2e37ba56&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e37ba56"]])

export default __exports__